webpackJsonp([263791100135453],{

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo_cesartia = __webpack_require__(51);
	
	var _logo_cesartia2 = _interopRequireDefault(_logo_cesartia);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return (
	    // <div style={{ background: 'rebeccapurple', marginBottom: '1.45rem' }} >
	    //   <div style={{ margin: '0 auto', maxWidth: 960, padding: '1.45rem 1.0875rem' }}>
	    //     <h1 style={{ margin: 0 }}>
	    //       <Link to="/" style={{ color: 'white', textDecoration: 'none'}}>
	    //         Gatsby
	    //       </Link>
	    //     </h1>
	    //   </div>
	
	    _react2.default.createElement(
	      'div',
	      { className: 'm__logo-container m__logo-container--header ' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        _react2.default.createElement('img', { src: _logo_cesartia2.default, alt: 'Logo' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'esartia'
	        )
	      ),
	      _react2.default.createElement('span', { id: 'horizontal' })
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 190:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _createReactClass = __webpack_require__(62);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _header = __webpack_require__(22);
	
	var _header2 = _interopRequireDefault(_header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = (0, _createReactClass2.default)({
	  displayName: 'AboutPage',
	  render: function render() {
	    return _react2.default.createElement(
	      'div',
	      { style: { height: '100%', width: '100%' } },
	      _react2.default.createElement(_header2.default, null),
	      _react2.default.createElement(
	        'main',
	        { className: 't__about' },
	        _react2.default.createElement(
	          'p',
	          null,
	          ' My name is Christopher Esartia. I am a full-stack developer located in New York.'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'm__about-block' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Experience'
	          ),
	          _react2.default.createElement(
	            'aside',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              '2016 - 2017:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Joined King & Partners as a Front-End developer. Lead front-end development for projects such as itsu.com and Tommie Copper. Introduced Atomic Design principles to codebase to help streamline front-end development. Also did back-end work using Rails and Node.js.'
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              '2015 - 2016:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Joined Moxie Media Group as a junior full-stack developer. Gained a lot of front-end experience on projects, ranging from template wire-framing and design, to implementing GSAP and animations with Angular.js. Learned a lot about back-end structures too, such as implementing JSON fields, handling cron jobs, writing automation scripts using Casper.js and Phantom.js'
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              '2014 - 2015:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Started a company called TwinNinja with a friend and built several prototype sites targeted for consumer spending and travel planning using Ember.js'
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              '2013 - 2014:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Intern at Tiger Party New York. Developed sites and applications using HTML, CSS, SASS, javaScript, jQuery and PHP'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'm__about-block' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Tools'
	          ),
	          _react2.default.createElement(
	            'aside',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Frameworks'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              ' React, Redux, Flux, React-Native, Vue, Vuex '
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Language'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'JavaScript/ES7/ES6/ES5, HTML5, SASS/Stylus/CSS, Jade/Haml '
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Methodologies'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Atomic Design, BEM, Modular components'
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            null,
	            _react2.default.createElement(
	              'h4',
	              null,
	              'Tools'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Git, vim, Visual Studio, Adobe Suites, Flexbox, CSS Grids, Node.js'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'm__about-block' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'Open-Source Projects'
	          ),
	          _react2.default.createElement(
	            'aside',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/Rulox/react-atomic-structure' },
	              'React-Atomic-Structure:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Package to help create new projects with Atomic Design principles setup up with React'
	            )
	          ),
	          _react2.default.createElement(
	            'aside',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://github.com/Oliphaunte/vue-atomic-structure' },
	              'Vue-Atomic-Structure:'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Package to help create new projects with Atomic Design principles setup up with Vue'
	            )
	          )
	        )
	      )
	    );
	  }
	});
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-6c86a29045a290474aa7.js